import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import moment from "moment";
// Constants
import { WEB_SERVICE_MIMS } from "../../../../config/constants";
// Components
import { Container, NewMessageButton, NewMessageText, NewMessageImgContainer, NewMessageImg } from "./styles";
import Axios from "../../../../config/axios";
import Popup from "../../../popup";
import MessageCanvas from "../messageCanvas";
// Assets
import CrossImg from "../../../../assets/icons/ico_cross.svg";

const NewMessage = ({ messages, patientProtocols, setIsLoadingMessages, rechargeMessages, setRechargeMessages }) => {
  const [isShowingNewMessageForm, setIsShowingNewMessageForm] = useState(false);
  // Message fields
  const [messageType, setMessageType] = useState("GREETING");
  const [protocolId, setProtocolId] = useState(0);
  const [messageText, setMessageText] = useState("");
  const [showOnlyOnce, setShowOnlyOnce] = useState(false);
  const [launchTime, setLaunchTime] = useState("");
  const [launchDays, setLaunchDays] = useState([]);
  const [deleteTime, setDeleteTime] = useState("");

  const { patientId } = useParams();
  const [t] = useTranslation("global");

  const getToday = () => {
    const days = ["SUNDAY", "MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY"];
    return [days[new Date(deleteTime).getDay()]];
  };

  const handleSaveMessage = (e) => {
    e.preventDefault();
    if (messageType === "ON_PROTOCOL" && !protocolId) return toast.error(t("coachMessages_alerts_selectProtocol"));
    if (!messageText) return toast.error(t("coachMessages_alerts_addMessage"));
    if (!showOnlyOnce && !launchDays.length) return toast.error(t("coachMessages_alerts_selectDays"));
    if (!launchTime && messageType === "NOTIFICATION") return toast.error(t("coachMessages_alerts_selectTime"));
    if (showOnlyOnce && !deleteTime) return toast.error(t("coachMessages_alerts_selectDate"));
    if (deleteTime && !moment(new Date(deleteTime), "DD/MM/YYYY", true).isValid())
      return toast.error(t("coachMessages_alerts_selectValidDate"));
    if (deleteTime && deleteTime < new Date()) return toast.error(t("coachMessages_alerts_selectHigherDate"));

    const message = {
      MESSAGE: messageText,
      SENDER: "CLINICIAN",
      TYPE: messageType,
      SHOW_ONLY_ONCE: showOnlyOnce,
      DELETE_TIME: deleteTime ? deleteTime : null,
      LAUNCH_TIME: messageType === "NOTIFICATION" ? launchTime : "10:00",
      LAUNCH_DAYS: !showOnlyOnce ? launchDays : getToday(),
    };
    if (messageType === "ON_PROTOCOL") {
      message.PROTOCOL_ID = protocolId;
    }

    Axios("post", `${WEB_SERVICE_MIMS}/coach-messages/add-message/${patientId}`, message)
      .then(({ data }) => {
        if (data.addedMessage) {
          toast.success(t("coachMessages_alerts_createdMessageSuccessfully"));
          setIsLoadingMessages(true);
          setRechargeMessages(!rechargeMessages);
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("Endpoint to add message", error);
      });
  };

  const showingNewMessageForm = () => {
    const greetingMessages = messages.filter((message) => message.TYPE === "GREETING");
    if (greetingMessages.length) return toast.error(t("coachMessages_alerts_messageAlreadyCreated"));
    setIsShowingNewMessageForm(true);
  };

  return (
    <>
      <Container>
        <NewMessageButton onClick={showingNewMessageForm}>
          <NewMessageText>{t("coachMessages_addMessage")}</NewMessageText>
          <NewMessageImgContainer>
            <NewMessageImg src={CrossImg} alt="ico-new-message" />
          </NewMessageImgContainer>
        </NewMessageButton>
      </Container>
      <Popup isShowed={isShowingNewMessageForm} setIsShowed={setIsShowingNewMessageForm}>
        <MessageCanvas
          title={t("coachMessages_addMessage")}
          isOnlyDisplayed={true}
          patientProtocols={patientProtocols}
          messageType={messageType}
          setMessageType={setMessageType}
          protocolId={protocolId}
          setProtocolId={setProtocolId}
          messageText={messageText}
          setMessageText={setMessageText}
          showOnlyOnce={showOnlyOnce}
          setShowOnlyOnce={setShowOnlyOnce}
          launchDays={launchDays}
          setLaunchDays={setLaunchDays}
          launchTime={launchTime}
          setLaunchTime={setLaunchTime}
          deleteTime={deleteTime}
          setDeleteTime={setDeleteTime}
          setIsShowingMessageForm={setIsShowingNewMessageForm}
          saveMessage={handleSaveMessage}
        />
      </Popup>
    </>
  );
};

export default NewMessage;
